import Cookies from 'js-cookie';

var utms = ["utm_source", "utm_medium", "utm_campaign", "utm_term", "utm_content"];

var hostnameToWildcard = function hostnameToWildcard(hostname) {
  var hostParts = hostname.split(".");
  return "." + (hostParts.length > 2 ? hostParts.slice(1).join(".") : hostParts.join("."));
};

var extend = function extend(defaults, options) {
  var extended = {};
  var prop;
  for (prop in defaults) {
    if (Object.prototype.hasOwnProperty.call(defaults, prop)) {
      extended[prop] = defaults[prop];
    }
  }
  for (prop in options) {
    if (Object.prototype.hasOwnProperty.call(options, prop)) {
      extended[prop] = options[prop];
    }
  }
  return extended;
};

// Stores marketing params as cookies
// Returns params set while executing
var index = function () {
  var referrer = document.referrer ? new window.URL(document.referrer) : null;
  var location = new window.URL(document.location.href);
  // Cookies are set for all subdomains, e.g. `.livechatinc.com`
  var cookieDomain = hostnameToWildcard(location.hostname);
  var cookieDefaults = {
    domain: cookieDomain,
    samesite: 'none',
    secure: true
  };

  var out = {};
  var setParam = function setParam(name, value, options) {
    var settings = extend(cookieDefaults, options);
    Cookies.set(name, value, settings);
    out[name] = value;
  };

  // Handle UTM params
  var foundUtms = utms.filter(function (utm) {
    return location.searchParams.has(utm);
  });
  if (foundUtms.length) {
    // Prevent UTM params overlapping:
    // when any param is present in query
    // remove all saved previously
    utms.forEach(function (utm) {
      return Cookies.remove(utm, { domain: cookieDomain });
    });

    // Store UTM params
    // Duration: session
    foundUtms.forEach(function (utm) {
      setParam(utm, location.searchParams.get(utm));
    });
  }

  // Store referrer
  // Duration: session, overwritten
  // Omit internal referrers
  if (referrer && hostnameToWildcard(referrer.hostname) !== hostnameToWildcard(location.hostname)) {
    setParam("referrer", referrer.href);
  }

  // Store landing page
  // Duration: session
  if (!Cookies.get("landing_page")) {
    setParam("landing_page", location.origin + location.pathname);
  }

  // Store discount
  // Duration: session
  if (location.searchParams.has("discount")) {
    setParam("discount", location.searchParams.get("discount"));
  }

  // Store affiliation
  // Duration: 120 days
  if (location.searchParams.has("a")) {
    setParam("partner_id", location.searchParams.get("a"), {
      expires: 120
    });
  }

  if (location.searchParams.has("partner_id")) {
    setParam("partner_id", location.searchParams.get("partner_id"), {
      expires: 120
    });
  }

  // Store promocode
  // Duration: 120 days
  if (location.searchParams.has("partner")) {
    setParam("promocode", location.searchParams.get("partner"), {
      expires: 120
    });
  }

  // http://shareasale.com/itp/lead.htm#_Toc522268050
  if (location.searchParams.has("sscid")) {
    setParam("sscid", location.searchParams.get("sscid"), {
      expires: 120
    });
  }

  return out;
};

export default index;
